import React from 'react';
import { TypographyVariants } from '../types';
import TypographyButtonSettings from './TypographyButtonSettings';
import TypographyInputSettings from './TypographyInputSettings';
import TypographyVariantSettings from './TypographyVariantSettings';

type Props = {
	fontFamilies: string[];
	values: Record<string, string>;
	setVariant: (path: string, value: string) => void;
	variant: TypographyVariants;
};

export default (props: Props) => {
	// eslint-disable-next-line react/destructuring-assignment
	switch (props.variant) {
		case 'button':
			return <TypographyButtonSettings {...props} />;
		case 'input':
			return <TypographyInputSettings {...props} />;
		default:
			return <TypographyVariantSettings {...props} />;
	}
};
